<!-- <div class="financeiro-item"> -->
<div class="periodo-status" (click)="financeiroCollapse.toggle()" [attr.aria-expanded]="!isFinanceiroCollapsed"
  aria-controls="collapseExample">
  <span class="strong__class">
    <!-- TODO obter financeiro.periodo -->
    financeiro.periodo
  </span>
  <span *ngIf="financeiro.pagoFatura" class="span__status">
    {{financeiro.pagoFatura ? 'Fechado' : 'Aberto'}}
  </span>
  <!-- <span *ngIf="financeiro.status === 'Pago'" style="color:var(--success)">
      {{financeiro.status}}
    </span> -->
  <img [ngClass]="{'rotate': isFinanceiroCollapsed}" src="/assets/images/simbolos/setaPreta.svg">
</div>
<div #financeiroCollapse="ngbCollapse" [(ngbCollapse)]="isFinanceiroCollapsed">
  <div class="collapse-financeiro-info">
    <span class="strong__class">
      ID:{{financeiro.codFatura}}
    </span>
    <span class="strong__class">
      Data: {{financeiro.dataFatura| date: 'dd/MM/yyyy'}}
    </span>
    <span class="strong__class">
      <!-- Tipo de Contrato: {{financeiro.tipoDeContrato}} -->
    </span>
    <span class="strong__class">
      <!-- Unidade: {{financeiro.unidade}} -->
    </span>
  </div>
  <div class="collapse-financeiro-buttons">
    <button>
      Baixar Boleto
    </button>
    <button>
      Baixar Fatura
    </button>
  </div>
</div>
<!-- </div> -->